import type { ReactNode } from 'react'

import { QueryProvider } from './QueryProvider'

/**
 * Punto único donde se envuelve la aplicación con sus proveedores de contexto.
 *
 * ¿Por qué agruparlos aquí en vez de anidarlos en main.tsx? Porque conforme
 * el proyecto crece se van sumando (tema, notificaciones, internacionalización)
 * y main.tsx acabaría siendo una pirámide de doce niveles de indentación.
 * Con este componente, main.tsx se mantiene en tres líneas y el orden de los
 * proveedores queda documentado en un solo lugar.
 *
 * ⚠️ EL ORDEN IMPORTA: un proveedor solo puede usar el contexto de los que
 * están POR ENCIMA de él. Si mañana agregas un proveedor de notificaciones que
 * necesita hacer peticiones, tiene que ir DENTRO de QueryProvider.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return <QueryProvider>{children}</QueryProvider>
}
